module.exports = __webpack_public_path__ + "media/SetB_L6_B.229c00d7.mp3";